/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@softlimit/theme-envy/build/requires/scripts/elements.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@softlimit/theme-envy/build/requires/scripts/elements.js ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

const elements = {
  'deferred-media': () => __webpack_require__.e(/*! import() | deferred-media */ "deferred-media").then(__webpack_require__.t.bind(__webpack_require__, /*! ./src/theme-envy/elements/deferred-media.js */ "./src/theme-envy/elements/deferred-media.js", 23)),
  'collection-rollover': () => __webpack_require__.e(/*! import() | collection-rollover */ "collection-rollover").then(__webpack_require__.t.bind(__webpack_require__, /*! ./src/theme-envy/elements/collection-rollover.js */ "./src/theme-envy/elements/collection-rollover.js", 23))}
// check all elements for presence in the Document and load if they are there
function dynamicElements() {
  Object.entries(elements).forEach(elm => {
    const domElm = document.querySelector(elm[0])
    if (domElm) {
      if (domElm.getAttribute('loading') === 'lazy') {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              loadElement(elm)
              domElm.setAttribute('loading', 'loaded')
              observer.disconnect()
            }
          })
        }, { rootMargin: '0px 0px 500px 0px', threshold: 0 })
        observer.observe(domElm)
        return
      }
      loadElement(elm)
    }
  })
}
dynamicElements()
function loadElement(elm) {
  // load the element
  elm[1]()
  // remove from Object so we don't need to check again
  delete elements[elm[0]]
}
// eslint-disable-next-line no-undef
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', dynamicElements)
}


/***/ }),

/***/ "./node_modules/@softlimit/theme-envy/build/requires/scripts/features.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/@softlimit/theme-envy/build/requires/scripts/features.js ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_oliviabeaty_dev_redshift_redshiftsports_src_theme_envy_features_variant_shipping_message_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./src/theme-envy/features/variant-shipping-message/index.js */ "./src/theme-envy/features/variant-shipping-message/index.js");
/* harmony import */ var _Users_oliviabeaty_dev_redshift_redshiftsports_src_theme_envy_features_variant_shipping_message_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_oliviabeaty_dev_redshift_redshiftsports_src_theme_envy_features_variant_shipping_message_index_js__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ "./node_modules/@softlimit/theme-envy/build/requires/scripts/public-path.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/@softlimit/theme-envy/build/requires/scripts/public-path.js ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/**
 * @file Sets the public path for Webpack to use in dynamic imports
 * @see https://webpack.js.org/guides/public-path/#on-the-fly
 */

/* eslint-disable no-undef */
/* eslint-disable camelcase */
// window.ThemeEnvy.publicPath is set in the theme-envy.liquid snippet
__webpack_require__.p = window.ThemeEnvy.publicPath


/***/ }),

/***/ "./src/theme-envy/features/variant-shipping-message/index.js":
/*!*******************************************************************!*\
  !*** ./src/theme-envy/features/variant-shipping-message/index.js ***!
  \*******************************************************************/
/***/ (() => {

if (document.querySelector('variant-shipping-message')) {
  class VariantShippingMessage extends HTMLElement {
    constructor() {
      super()
      // this.form = this.closest('form')
      // this.section = this.closest('[data-section-id]')
      // this.optionSelects = this.form?.querySelectorAll('select.single-option-selector')
      this.messages = this.querySelectorAll('[data-variant-message]')
      this.handleVariantChange = this.onVariantChange.bind(this)
    }

    connectedCallback() {
      document.addEventListener('variant:change', this.handleVariantChange)
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.handleVariantChange)
    }

    onVariantChange(e) {
      // const params = new URLSearchParams(window.location.search)
      // const variant = params.get('variant')

      const variant = e.detail.variant.id

      this.messages.forEach((message) => {
        const input = message.querySelector('input')
        if (parseInt(message.getAttribute('data-variant')) === variant) {
          input?.removeAttribute('disabled')
          message.classList.remove('tw-hidden')
          return
        }
        input?.setAttribute('disabled', '')
        message.classList.add('tw-hidden')
      })
    }
  }

  customElements.define('variant-shipping-message', VariantShippingMessage)
}

if (document.querySelector('cart-shipping-messages-properties')) {
  class CartShippingMessagesProperties extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      this.inputs = this.form?.querySelectorAll('input')
    }

    connectedCallback() {
      // if the form has inputs, submit it and reload the page
      if (!this.inputs.length) return
      this.updateProperties()
    }

    updateProperties() {
      // for each input, update the line item properties with cart/change.js
      this.getCart()
        .then((cart) => {
          // create array of promises and execute with Promise.all
          Promise.all(Array.from(this.inputs).map((input) => {
            const key = input.getAttribute('data-item-key')
            // get the existing properties of the key
            const properties = cart.items.find(item => item.key === key).properties || {}
            // set or update the property
            if (input.value === 'remove') {
              delete properties[input.name]
              return this.submit(input, properties)
            }
            properties[input.name] = input.value
            return this.submit(input, properties)
          }))
            .then(() => {
              // reload the page
              window.location.reload()
            })
        })
    }

    submit(input, properties) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: input.getAttribute('data-item-key'),
          properties
        })
      })
    }

    getCart() {
      // fetch and return the cart data
      return fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          return cart
        })
    }
  }

  customElements.define('cart-shipping-messages-properties', CartShippingMessagesProperties)
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames not based on template
/******/ 			if (chunkId === "deferred-media") return "" + chunkId + ".js?h=26ed8";
/******/ 			if (chunkId === "collection-rollover") return "" + chunkId + ".js?h=89d34";
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "redshiftsports:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat */
/******/ 	(() => {
/******/ 	  if (typeof __webpack_require__ !== 'undefined') {
/******/ 	    var oldGetScript = __webpack_require__.u;
/******/ 	    var oldLoadScript = __webpack_require__.e;
/******/ 	    var queryMap = new Map();
/******/ 	    var countMap = new Map();
/******/ 	    __webpack_require__.u = function (chunkId) {
/******/ 	      var result = oldGetScript(chunkId);
/******/ 	      return (
/******/ 	        result + (queryMap.has(chunkId) ? '?' + queryMap.get(chunkId) : '')
/******/ 	      );
/******/ 	    };
/******/ 	    __webpack_require__.e = function (chunkId) {
/******/ 	      var result = oldLoadScript(chunkId);
/******/ 	      return result.catch(function (error) {
/******/ 	        var retries = countMap.has(chunkId) ? countMap.get(chunkId) : 3;
/******/ 	        if (retries < 1) {
/******/ 	          var realSrc = oldGetScript(chunkId);
/******/ 	          error.message =
/******/ 	            'Loading chunk ' +
/******/ 	            chunkId +
/******/ 	            ' failed after 3 retries.\n(' +
/******/ 	            realSrc +
/******/ 	            ')';
/******/ 	          error.request = realSrc;
/******/ 	          throw error;
/******/ 	        }
/******/ 	        return new Promise(function (resolve) {
/******/ 	          setTimeout(function () {
/******/ 	            var retryAttempt = 3 - retries + 1;
/******/ 	            var retryAttemptString = '&retry-attempt=' + retryAttempt;
/******/ 	            const cacheBust = Date.now();
/******/ 	            queryMap.set(chunkId, cacheBust);
/******/ 	            countMap.set(chunkId, retries - 1);
/******/ 	            resolve(__webpack_require__.e(chunkId));
/******/ 	          }, 0);
/******/ 	        });
/******/ 	      });
/******/ 	    };
/******/ 	  }
/******/ 	})();
/******/ 	
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"theme-envy": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkredshiftsports"] = self["webpackChunkredshiftsports"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!*********************************************************************************!*\
  !*** ./node_modules/@softlimit/theme-envy/build/requires/scripts/theme-envy.js ***!
  \*********************************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _public_path_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./public-path.js */ "./node_modules/@softlimit/theme-envy/build/requires/scripts/public-path.js");
/* harmony import */ var _public_path_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_public_path_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _elements_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./elements.js */ "./node_modules/@softlimit/theme-envy/build/requires/scripts/elements.js");
/* harmony import */ var _elements_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_elements_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _features_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./features.js */ "./node_modules/@softlimit/theme-envy/build/requires/scripts/features.js");
/**
 * @file Our Webpack entrypoint for ThemeEnvy
 */





})();

/******/ })()
;